import {
    ApiShopperLandingPage,
    ApiShopperLandingPageLink,
    VLPVariant,
} from '@storefronts/common-types'
import Script from 'next/script'
import { VariantWithImage } from '../../types'
import { markVendorReady, runWhenReady } from './pixelRuntime'

export const Attentive: React.FC<{ landingPage: ApiShopperLandingPage }> = ({
    landingPage,
}) => {
    if (!landingPage.integrations.attentiveId) return null

    return (
        <>
            <Script
                id="attentive"
                strategy="afterInteractive"
                src={`https://cdn.attn.tv/${landingPage.integrations.attentiveId}/dtag.js`}
                onReady={() => markVendorReady('attentive')}
            ></Script>
        </>
    )
}

export class AttentiveTracker {
    static checkAttentive(): boolean {
        return (
            window.hasOwnProperty('attentive') &&
            window.attentive.hasOwnProperty('analytics')
        )
    }

    static trackProductView(
        link: ApiShopperLandingPageLink,
        variant: VLPVariant,
    ) {
        runWhenReady('attentive', () => {
            if (!AttentiveTracker.checkAttentive()) return

            window.attentive.analytics.productView({
                items: [
                    {
                        productId: link.shopifyId,
                        productVariantId: variant.shopifyId,
                        name: link.title,
                        productImate: link.imageUrl,
                        price: {
                            value: `${(variant.price.price / 100).toFixed(2)}`,
                            currency: 'USD',
                        },
                        quantity: 1,
                    },
                ],
            })
        })
    }

    static trackAddToCart(variant: VariantWithImage, cartId: string) {
        runWhenReady('attentive', () => {
            if (!AttentiveTracker.checkAttentive()) return

            window.attentive.analytics.addToCart({
                items: [
                    {
                        productId: variant.link.shopifyId,
                        productVariantId: variant.shopifyId,
                        name: variant.link.title,
                        productImate: variant.imageUrl,
                        price: {
                            value: `${(variant.price.price / 100).toFixed(2)}`,
                            currency: 'USD',
                        },
                        quantity: 1,
                    },
                ],
                cart: {
                    cartId,
                },
            })
        })
    }
}
